import { render, staticRenderFns } from "./FormTransportSwitch.vue?vue&type=template&id=b06b0138&scoped=true&"
import script from "./FormTransportSwitch.vue?vue&type=script&lang=js&"
export * from "./FormTransportSwitch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b06b0138",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VSwitch})
